import React from 'react'
import { generateRoomOccupants } from 'lib/offer/occupancyUtils'
import { getCheckoutDate } from 'selectors/offerPage/offerPageSelectors'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import Group from 'components/utils/Group'
import WalledContent from 'components/Common/WalledContent'
import BedbankPackageTileCheapestPricing from './BedbankPackageTileCheapestPricing'
import BedbankCancellationPolicy from '../BedbankCancellationPolicy'
import BedbankPromotionDetails from '../BedbankPromotionDetails'
import BodyText from 'LuxKit/Typography/BodyText'

const defaultRooms = [generateRoomOccupants()]

interface Props {
  rate: App.BedbankRate;
  offer: App.BedbankOffer;
  rooms?: Array<App.Occupants>;
  checkInDate?: string;
  checkOutDate?: string;
  packageView: App.BedbankOfferPackageView;
  hasMultipleCancellationPolicies: boolean;
  showPartialRefundPolicyLabel?: boolean;
  onShowRoomDetails: () => void;
}

function BedbankRoomCheapestOptionRateMobile(props: Props) {
  const {
    rate,
    offer,
    rooms = defaultRooms,
    checkInDate,
    checkOutDate,
    packageView,
    hasMultipleCancellationPolicies,
    showPartialRefundPolicyLabel,
    onShowRoomDetails,
  } = props

  const { bundleRates, promotions } = packageView
  const bundleRate = bundleRates.find((bundleRate) => bundleRate.id === rate.id) ?? rate
  const promotion = promotions[rate.promotionId ?? '']

  return (
    <Group direction="vertical" gap={16}>
      {promotion && <BedbankPromotionDetails
        checkInDate={checkInDate}
        checkOutDate={checkOutDate}
        offer={offer}
        promotion={promotion}
        rate={rate}
      />}

      <Group direction="vertical" gap={8} noDisplayWhenEmpty>
        {hasMultipleCancellationPolicies && (
          <BodyText variant="medium">
            <BodyText variant="medium" weight="bold" colour="highlight-secondary" as="span">
              {showPartialRefundPolicyLabel ? 'Partial refund' : 'Flexible cancellation'}
            </BodyText>
            {' '}
            options available
          </BodyText>
        )}
        {!promotion && !hasMultipleCancellationPolicies && <BedbankCancellationPolicy
          rate={rate}
          offer={offer}
          showNonCancellation
        />}
      </Group>

      <WalledContent enforced={offer.walledGarden} hidePricing={offer.hidePricing}>
        <BedbankPackageTileCheapestPricing
          promotions={promotion}
          rate={rate}
          bundleRate={bundleRate}
          rooms={rooms}
          offer={offer}
          checkIn={checkInDate}
          packageView={packageView}
          onShowRoomDetails={onShowRoomDetails}
        />
      </WalledContent>
    </Group>
  )
}

export default withOfferPageAndReduxState((offerState, appState) => ({
  checkInDate: offerState.checkInDate,
  checkOutDate: getCheckoutDate(offerState),
  rooms: offerState.rooms,
  flightOrigin: offerState.airport,
  isLoggedIn: !!appState.auth.account.memberId,
  isSpoofed: appState.auth.account.isSpoofed,
  originAirport: offerState.airport,
  tripPlannerTripId: appState.tripPlanner.currentTripId,
}), BedbankRoomCheapestOptionRateMobile)
